import React, { useState, useEffect } from 'react'
import { Container } from 'react-awesome-styled-grid'

import { useWindowSize } from '@react-hook/window-size'
import PropTypes from 'prop-types'

import Icon from '../../helpers/Icon'
import { siteMenu, juridicMenu } from './menu'
import * as S from './styled'

const Footer = ({ cta }) => {
  const [width] = useWindowSize()
  const [open, setOpen] = useState(true)

  let accordionCount = 0

  useEffect(() => {
    setOpen(width >= 769)
  }, [width])

  return (
    <>
      {cta && (
        <S.FooterConversion
          headText={cta.headText}
          footText={cta.footText}
          actions={cta.actions}
          textColor="white"
          bgColor="blue800"
        />
      )}
      <S.FooterWrapper withCta={cta}>
        <Container>
          <S.FooterContent>
            <S.FooterBrand>
              <Icon name="superlogica-color" size={50} color="neutral900" />
            </S.FooterBrand>
            <S.FooterNav>
              <S.FooterAccordion target="grandchild" onlyMobile>
                {siteMenu.map((group, key) => (
                  <S.FooterNavCol key={key}>
                    {group.map(({ label, menu }, key) => (
                      <S.FooterAccordionItem
                        key={key}
                        itemId={accordionCount++}
                        label={label}
                        open={open}
                        setOpen={setOpen}
                        onlyMobile={true}
                      >
                        <S.FooterMenu key={key}>
                          {menu.map(({ label, to }, key) => (
                            <S.FooterNavItem key={key}>
                              <S.FooterNavLink
                                as="a"
                                color="neutral500"
                                href={to}
                                title={label}
                              >
                                {label}
                              </S.FooterNavLink>
                            </S.FooterNavItem>
                          ))}
                        </S.FooterMenu>
                      </S.FooterAccordionItem>
                    ))}
                  </S.FooterNavCol>
                ))}
              </S.FooterAccordion>
            </S.FooterNav>
          </S.FooterContent>
          <S.FooterJuridic>
            <S.FooterText>
              Para mais informações entre em contato no <b>0800 709 6800</b> ou{' '}
              <b>(19) 4009 6800</b> em horário comercial das 8:00 às 18:00 ou
              entre em contato com nossa assessoria de imprensa:{' '}
              <b>imprensa@superlogica.com</b>.
              <br /> Rua Joaquim Vilac nº 501, Vila Teixeira - CEP. 13.032-385 -
              Campinas/SP.
            </S.FooterText>
            <S.FooterJuridicBar>
              <S.FooterText>
                Copyright © 2020 Superlógica Tecnologias S.A. Todos os direitos
                reservados. CNPJ nº 04.833.541/0001-51
              </S.FooterText>
              <S.FooterJuridicMenu>
                <S.FooterMenu>
                  {juridicMenu.map(({ label, to }, key) => (
                    <S.FooterNavItem key={key}>
                      <S.FooterNavLink
                        as="a"
                        color="neutral500"
                        href={to}
                        title={label}
                      >
                        {label}
                      </S.FooterNavLink>
                    </S.FooterNavItem>
                  ))}
                </S.FooterMenu>
              </S.FooterJuridicMenu>
            </S.FooterJuridicBar>
          </S.FooterJuridic>
        </Container>
      </S.FooterWrapper>
    </>
  )
}

Footer.propTypes = {
  cta: PropTypes.object
}

export default Footer
